import styled from 'styled-components';

type Props = {
  size?: 12 | 16 | 20 | 24 | 32 | 48 | 64;
  color?: string;
};

export const StyledIcon = styled.svg<Props>`
  display: block;
  width: ${({ size }) => size ?? 16}px;
  height: ${({ size }) => size ?? 16}px;
  fill: ${({ color }) => color ?? 'currentColor'};
  flex: 0 0 auto;
`;
